// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.layers-sidebar {
  z-index: 250; }
  .layers-sidebar .dropdown-menu.show {
    width: 360px;
    overflow: scroll; }
  .layers-sidebar .row {
    margin: unset;
    padding: unset;
    width: unset;
    justify-content: center; }
    .layers-sidebar .row .col {
      margin: unset;
      padding: unset; }
  .layers-sidebar .accordion-body {
    padding: 4px;
    padding-top: 8px;
    margin-top: 5px; }
  .layers-sidebar .layers-header-primary-level button {
    padding-left: 1px; }
  .layers-sidebar .layers-header-secondary-level button {
    padding-left: 15px; }
  .layers-sidebar .thumbnail {
    text-align: center;
    width: 100px;
    margin: unset;
    padding: unset; }
    .layers-sidebar .thumbnail .disabled {
      background-color: rgba(0, 0, 0, 0.337); }
    .layers-sidebar .thumbnail img.layer {
      width: 100px;
      cursor: pointer;
      width: 85px;
      height: 80px;
      background-color: rgba(255, 255, 0, 0.446);
      border-radius: 8px;
      object-fit: cover; }
    .layers-sidebar .thumbnail img.layer:hover {
      border: 3px solid #4fc2d9;
      box-sizing: border-box;
      border-radius: 10px;
      object-fit: cover; }
    .layers-sidebar .thumbnail img.check {
      position: relative;
      left: 25px;
      bottom: 80px;
      visibility: hidden; }
    .layers-sidebar .thumbnail .description {
      font-size: 12px;
      position: relative;
      left: 0px;
      top: -20px;
      text-align: center;
      display: flex;
      justify-content: center;
      font-weight: 500;
      min-width: 80px; }
  .layers-sidebar .thumbnail.selected img.layer {
    border: 3px solid #4fc2d9;
    box-sizing: border-box;
    border-radius: 10px; }
  .layers-sidebar .thumbnail.selected img.check {
    visibility: inherit; }
  .layers-sidebar .queried-layers {
    max-height: 300px;
    overflow-y: auto;
    background-color: #01254f;
    color: #dcd7d7;
    border-radius: 3px; }

button {
  border: 0 !important; }

.accordion-button {
  color: white;
  background-color: #18244c;
  border: 0px !important;
  font-size: 16px; }

.accordion-button::after {
  border: 0px !important;
  filter: invert(100%); }

.accordion-button:not(.collapsed)::after {
  filter: invert(50%);
  border: 0px !important;
  color: white !important; }

.custom-layers-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 1rem; }
  .custom-layers-container .custom-layer {
    width: calc(30% - 10px);
    margin: 0 10px;
    box-sizing: border-box;
    justify-content: center;
    flex-direction: column; }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/layout/Layers/layers.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACnBrD;EACE,YAAY,EAAA;EADd;IAGI,YAAY;IACZ,gBAAgB,EAAA;EAJpB;IAQI,aAAa;IACb,cAAc;IACd,YAAY;IACZ,uBAAuB,EAAA;IAX3B;MAcM,aAAa;MACb,cAAc,EAAA;EAfpB;IAoBI,YAAY;IACZ,gBAAgB;IAChB,eAAe,EAAA;EAtBnB;IA2BM,iBAAiB,EAAA;EA3BvB;IAiCM,kBAAkB,EAAA;EAjCxB;IAsCI,kBAAkB;IAClB,YAzCQ;IA0CR,aAAa;IACb,cAAc,EAAA;IAzClB;MA4CM,sCAAsC,EAAA;IA5C5C;MAgDM,YAlDM;MAmDN,eAAe;MACf,WAAW;MACX,YAAY;MACZ,0CAA0C;MAC1C,kBAAkB;MAClB,iBAAiB,EAAA;IAtDvB;MA0DM,yBD7DsB;MC8DtB,sBAAsB;MACtB,mBAAmB;MACnB,iBAAiB,EAAA;IA7DvB;MAiEM,kBAAkB;MAClB,UAAU;MACV,YAAY;MACZ,kBAAkB,EAAA;IApExB;MAwEM,eAAe;MACf,kBAAkB;MAClB,SAAS;MACT,UAAU;MACV,kBAAkB;MAClB,aAAa;MACb,uBAAuB;MACvB,gBAAgB;MAChB,eAAe,EAAA;EAhFrB;IAsFM,yBDzFsB;IC0FtB,sBAAsB;IACtB,mBAAmB,EAAA;EAxFzB;IA2FM,mBAAmB,EAAA;EA3FzB;IAgGI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,kBAAkB,EAAA;;AAItB;EACE,oBAAoB,EAAA;;AAGtB;EACE,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,eAAe,EAAA;;AAGjB;EACE,sBAAsB;EACtB,oBAAoB,EAAA;;AAGtB;EACE,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB,EAAA;;AAGzB;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,aAAa,EAAA;EAJf;IAOI,uBAAuB;IACvB,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB,EAAA","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import \"../../theme/_variables.scss\";\n\n$size: 100px;\n\n.layers-sidebar {\n  z-index: 250;\n  .dropdown-menu.show {\n    width: 360px;\n    overflow: scroll;\n  }\n\n  .row {\n    margin: unset;\n    padding: unset;\n    width: unset;\n    justify-content: center;\n\n    .col {\n      margin: unset;\n      padding: unset;\n    }\n  }\n\n  .accordion-body {\n    padding: 4px;\n    padding-top: 8px;\n    margin-top: 5px;\n  }\n\n  .layers-header-primary-level {\n    button {\n      padding-left: 1px;\n    }\n  }\n\n  .layers-header-secondary-level {\n    button {\n      padding-left: 15px;\n    }\n  }\n\n  .thumbnail {\n    text-align: center;\n    width: $size;\n    margin: unset;\n    padding: unset;\n\n    .disabled {\n      background-color: rgba(0, 0, 0, 0.337);\n    }\n\n    img.layer {\n      width: $size;\n      cursor: pointer;\n      width: 85px;\n      height: 80px;\n      background-color: rgba(255, 255, 0, 0.446);\n      border-radius: 8px;\n      object-fit: cover;\n    }\n\n    img.layer:hover {\n      border: 3px solid $secundaryFontColor;\n      box-sizing: border-box;\n      border-radius: 10px;\n      object-fit: cover;\n    }\n\n    img.check {\n      position: relative;\n      left: 25px;\n      bottom: 80px;\n      visibility: hidden;\n    }\n\n    .description {\n      font-size: 12px;\n      position: relative;\n      left: 0px;\n      top: -20px;\n      text-align: center;\n      display: flex;\n      justify-content: center;\n      font-weight: 500;\n      min-width: 80px;\n    }\n  }\n\n  .thumbnail.selected {\n    img.layer {\n      border: 3px solid $secundaryFontColor;\n      box-sizing: border-box;\n      border-radius: 10px;\n    }\n    img.check {\n      visibility: inherit;\n    }\n  }\n\n  .queried-layers {\n    max-height: 300px;\n    overflow-y: auto;\n    background-color: #01254f;\n    color: #dcd7d7;\n    border-radius: 3px;\n  }\n}\n\nbutton {\n  border: 0 !important;\n}\n\n.accordion-button {\n  color: white;\n  background-color: #18244c;\n  border: 0px !important;\n  font-size: 16px;\n}\n\n.accordion-button::after {\n  border: 0px !important;\n  filter: invert(100%);\n}\n\n.accordion-button:not(.collapsed)::after {\n  filter: invert(50%);\n  border: 0px !important;\n  color: white !important;\n}\n\n.custom-layers-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding: 1rem;\n\n  .custom-layer {\n    width: calc(30% - 10px);\n    margin: 0 10px;\n    box-sizing: border-box;\n    justify-content: center;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
